import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['ohm'] as const;
const unit = z.literal('ohm').default('ohm');

// Range-enabled resistance (ESR, port/series resistance, connection resistance) stores its
// nominal under `nom` alongside an optional min/max spread (DEV-9187).
const validator = AbstractMeasurement.nomOptionalMinMax
    .extend({
        unit,
    })
    .default({});

// Plain single-value resistance for fields that were not range-enabled (droop resistance,
// earthing impedance). These keep the legacy `{value, unit}` shape, so no migration is needed.
const valueValidator = AbstractMeasurement.value
    .extend({
        unit,
    })
    .default({});

export const Resistance = {
    validator,
    validators: {
        value: valueValidator,
        unit,
    },
    units,
};

export type Resistance = z.infer<typeof validator>;
